<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>

<app-mask-loader></app-mask-loader>
